/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { CompanyUpdateEmailComponent } from './CompanyUpdateEmailComponent'
import type { GlobalAboutComponent } from './GlobalAboutComponent'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { GlobalEmbedComponent } from './GlobalEmbedComponent'
import type { GlobalMediaComponent } from './GlobalMediaComponent'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
import type { ProfilingProfileComponent } from './ProfilingProfileComponent'
export type CompanyRequest = {
  data: {
    status: CompanyRequest.status
    name: string
    slug?: string
    logo?: number | string
    about?: GlobalAboutComponent
    address?: GlobalAddressComponent
    highlights?: GlobalMediaComponent
    embeds?: Array<GlobalEmbedComponent>
    verified?: boolean
    departments?: Array<number | string>
    tags?: Array<number | string>
    users?: Array<number | string>
    vacancies?: Array<number | string>
    locations?: Array<number | string>
    reviews?: Array<number | string>
    lastAddressStatus?: string
    interactions?: Array<number | string>
    profile?: ProfilingProfileComponent
    lastUpdateEmail?: CompanyUpdateEmailComponent
    appointments?: Array<number | string>
    placements?: Array<number | string>
    tokens?: number
    candidates?: Array<number | string>
    matchings?: Array<number | string>
    BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
    media?: Array<number | string>
    filterTags?: Array<ProfilingFilterTagComponent>
    finishedOnboarding?: boolean
    messages?: Array<number | string>
    hasPremium?: boolean
    talentpools?: Array<number | string>
    referrals?: Array<number | string>
    sentReferrals?: Array<number | string>
    disableGeoFilter?: boolean
  }
}
export namespace CompanyRequest {
  export enum status {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
  }
}
